import { AccountDto } from './accounts.dtos';
import { BaseListResponseDto, PaginationQueryParams, SortDirectionQueryParams } from './common.dtos';

export enum SignUpStatusDto {
  addressStep = 'addressStep',
  securityStep = 'securityStep',
  done = 'done',
}

export enum OfferOrderListVisibleColumnDto {
  ClearingFirm = 'clearingFirm',
  StatementReceivedAt = 'statementReceivedAt',
  AcatSentAt = 'acatSentAt',
  AcatReceivedAt = 'acatReceivedAt',
  AcatSubmittedToExternalAt = 'acatSubmittedToExternalAt',
  AcatResubmittedToExternalAt = 'acatResubmittedToExternalAt',
  RejectReason = 'rejectReason',
  Notes = 'notes',
  Representatives = 'representatives',
}

export interface UserDashboardOfferOrderListSettingsDto {
  visibleColumns: OfferOrderListVisibleColumnDto[];
}

export interface UserDashboardSettingsDto {
  offerOrderList: UserDashboardOfferOrderListSettingsDto;
}

export interface BaseUserDto {
  id: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  suffix?: string;
  email: string;
  phoneNumber: string;
  signUpStatus: SignUpStatusDto;
  isMfaEnabled: boolean;
  isMigrated: boolean;
  isLocked: boolean;
  isClosed: boolean;
  lockReason?: string;
  isApproved: boolean;
  lastUsedAccountId?: string;
  hasAccounts?: boolean;
  address?: {
    state: string;
    country: string;
  };
  createdAt?: string;
  updatedAt?: string;
  isApprovedAt?: string;
  createdBy?: string;
  updatedBy?: string;
  isApprovedBy?: string;
}

export interface UserDto extends BaseUserDto {
  postcloseOffers: string[];
  accounts: AccountDto[];
  dashboardSettings?: UserDashboardSettingsDto;
}

export interface LoginUserBodyDto {
  email: string;
  password: string;
}
export interface LoginUserDto {
  body: LoginUserBodyDto;
}
export interface LoginUserWithChallengeResponseDto {
  session: string;
  phoneNumber: string;
}

// NOTE: when react-admin starts supporting mfa then LoginUserResponseDto by updated to include session
export type LoginUserResponseDto = {
  user: UserDto;
  accessToken: string;
  refreshToken: string;
  idToken: string;
  tbToken: string;
};

export interface BaseUserParamsDto {
  id: string;
}

export interface BaseUserQueryParamsDto {
  id: string;
}

export enum GetUserListSortByQueryParamTypeDto {
  FirstName = 'firstName',
  LastName = 'lastName',
  Email = 'email',
  IsLocked = 'isLocked',
  IsClosed = 'isClosed',
  IsApproved = 'isApproved',
  CreatedAt = 'createdAt',
}

export interface GetUserListQueryParamsDto extends Partial<PaginationQueryParams>, Partial<SortDirectionQueryParams> {
  sortBy: GetUserListSortByQueryParamTypeDto;
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string;
  hasAccounts?: boolean;
}

export interface GetUserListDto {
  queryParams?: GetUserListQueryParamsDto;
}

export interface GetUserDto {
  params: BaseUserParamsDto;
}

export interface GetUserListResponseDto extends BaseListResponseDto<BaseUserDto[]> {}

export interface LockUserDto {
  params: BaseUserParamsDto;
}

export interface UnlockUserDto {
  params: BaseUserParamsDto;
}

export interface CloseUserDto {
  params: BaseUserParamsDto;
}

export interface ApproveUserDto {
  params: BaseUserParamsDto;
}

export interface UpdateUserMfaPreferencesDto {
  queryParams: BaseUserParamsDto;
  body: {
    isEnabled: boolean;
  };
}

export interface UpdateUserPostcloseOffersBodyDto {
  offerIds: string[];
}

export interface UpdateUserPostcloseOffersDto {
  params: BaseUserParamsDto;
  body: UpdateUserPostcloseOffersBodyDto;
}

export interface UpdateUserDashboardOfferOrderListSettingsDto {
  visibleColumns: OfferOrderListVisibleColumnDto[];
}

export interface UpdateUserDashboardSettingsBodyDto {
  offerOrderList: UpdateUserDashboardOfferOrderListSettingsDto | null;
}

export interface UpdateUserDashboardSettingsDto {
  body: UpdateUserDashboardSettingsBodyDto;
}
